import { storageListSelect, staffListSelect, getListMethod, delListMethod } from "@/utils/api";
export const methodlist = {
    data() {
        return {
            documentTypeList: [],
            warehouseList: [],
            agentList: [],
            dataSource: [],
            formData: {
                contactCustomerName: ''
            },

            ipagination: {
                current: 1,
                pageSize: 10,
                showTotal: (total, range) => {
                    return range[0] + "-" + range[1] + " 共" + total + "条"
                },
                showQuickJumper: true,
                showSizeChanger: true,
                total: 100
            }, // 分页参数 

            numObj: {
                totalNumber: 0,
                notConfirm: 0,
                yesConfirm: 0
            },
            dateValue: null,
            tableHeight: null, // 表格高度
            contentHeight: '',
            tableHeight: ''
        }
    },
    activated() {
        this.init()
    },
    // 实时控制页面布局
    created () {
        window.addEventListener('resize', this.calculateTableHeight)
    },
    beforeDestroy: function () {
        window.removeEventListener('resize', this.calculateTableHeight)
    },
    methods: {
        init() {
            this.calculateTableHeight() // 计算高度
            this.getMenuList()
            this.getStorageList()
            this.getStaffListSelect()
        },
        /**
         * 方法说明：表格高度计算
         * @method calculateTableHeight
         */
        calculateTableHeight() {
            let _that = this
            setTimeout(function() {
                let tdHeight = document.getElementsByTagName('tr')[0].offsetHeight
                let header = document.getElementById("header").offsetHeight;
                let breadcrumb = document.getElementById("breadcrumb").offsetHeight;
                let pageHeight = document.getElementById('content').offsetHeight
                let makeTop = document.getElementById('page-top').offsetHeight
                if (_that.$options.name == 'makeOffersList') {
                    let tabsTitleHeight = document.getElementsByClassName('ant-tabs-top-bar')[1].offsetHeight
                    _that.contentHeight = pageHeight - makeTop - header - breadcrumb - tdHeight * 0.8
                    _that.tableHeight = _that.contentHeight - tdHeight - tabsTitleHeight
                } else {
                    _that.contentHeight = pageHeight - makeTop - header - breadcrumb - tdHeight * 0.8
                    _that.tableHeight = _that.contentHeight - tdHeight
                }
            }, 50)
        },
        // 选择筛选日期
        changeData(date, dateString) {
            this.dateValue = date
            this.formData.startTime = dateString[0]
            this.formData.endTime = dateString[1]
        },
        // 获取仓库列表
        getStorageList() {
            let params = new FormData()
            params.append("companyStoreId", this.$store.state.userInfo.companyStoreId)
            storageListSelect(params).then((res) => {
                if (res.code == 200) {
                    this.warehouseList = res.result
                } else {
                    this.$message.error(res.logMessage)
                }
            })
        },
        // 获取经办人列表
        getStaffListSelect() {
            let params = new FormData()
            params.append("companyStoreId", this.$store.state.userInfo.companyStoreId)
            staffListSelect(params).then((res) => {
                if (res.code == 200) {
                    this.agentList = res.result
                } else {
                    this.$message.error(res.logMessage)
                }
            })
        },
        // 选择仓库
        selectWarehouse(e) {
            this.formData.inboundId = this.warehouseList[e].id
            this.formData.inStorageId = this.warehouseList[e].id
            this.formData.inStorageName = this.warehouseList[e].storageName
        },
        // 选择往来单位
        btnReceiptModel(e) {
            this.$refs.receipt.onOpen(e.target.value)
        },
        // 选择往来单位
        onSelectModel(data) {
            this.formData.contactCustomerName = data.contactCustomerName
            this.formData.contactCustomerId = data.id
        },
        changeContactCustomer() {
            if (!this.formData.contactCustomerName) {
                this.formData.contactCustomerId = ''
                this.btnInquire()
            }
        },
        // 选择经办人
        selectAgent(e) {
            this.formData.transactorId = this.agentList[e].id
            this.formData.transactorName = this.agentList[e].name
        },
        // 页面变化时回调
        onChangeIpagination(current) {
            this.ipagination.current = current
            this.getMenuList()
        },
        // 一页显示条数变化时回调
        onShowSizeChange(current, pageSize) {
            this.ipagination.current = current
            this.ipagination.pageSize = pageSize
            this.getMenuList()
        },
        // 重置数据
        btnResetData() {
            this.dateValue = null
            this.ipagination.current = 1
            this.ipagination.pageSize = 10
            this.formData.confirmFlag = ''
            this.formData = {
                contactCustomerName: ''
            }
            this.getMenuList()
        },
        // 筛选
        btnInquire() {
            this.ipagination.current = 1
            this.ipagination.pageSize = 10
            this.formData.confirmFlag = ''
            this.getMenuList()
        },
        // 切换类型
        callback(e) {
            this.ipagination.current = 1
            this.ipagination.pageSize = 10
            console.log(e)
            if (e == 1) {
                this.formData.confirmFlag = ''
            } else if (e == 2) {
                this.formData.confirmFlag = 0
            } else if (e == 3) {
                this.formData.confirmFlag = 1
            }
            this.getMenuList()
        },
        // 获取表格数据
        getMenuList() {
            this.dataSource = []
            let url = this.urlList.list
            let params = {
                code: this.formData.code,
                companyStoreId: this.$store.state.userInfo.companyStoreId,
                contactCustomerId: this.formData.contactCustomerId,
                keyWord: this.formData.keyWord,
                endTime: this.formData.endTime,
                startTime: this.formData.startTime,
                inStorageId: this.formData.inStorageId,
                transactorId: this.formData.transactorId,
                confirmFlag: this.formData.confirmFlag,
                inboundId: this.formData.inboundId
            }
            let data = {
                pageNo: this.ipagination.current,
                pageSize: this.ipagination.pageSize
            }
            this.$store.state.isLoding = true
            this.$store.state.tabLoding = true
            getListMethod(url, params, {}, data).then((res) => {
                if (res.success) {
                    this.dataSource = res.result.records
                    this.ipagination.total = parseInt(res.result.total)
                    this.$store.state.isLoding = false
                    this.$store.state.tabLoding = false
                }
            })
            if (this.urlList.num) {
                let query = {
                    companyStoreId: this.$store.state.userInfo.companyStoreId
                }
                getListMethod(this.urlList.num, {}, {}, query).then((res) => {
                    if (res.success) {
                        this.numObj = res.result
                    }
                })
            }
        },
        // 删除列表
        btnDeleteList(record) {
            let url = this.urlList.del
            let params = {}
            let data = {
                id: record.id
            }
            delListMethod(url, params, {}, data).then((res) => {
                if (res.success) {
                    this.$message.success('删除成功')
                    this.getMenuList()
                }
            })
        }
    }
}